import type { HierarchyRectangularNode } from 'd3-hierarchy';
import { isUndefined } from 'lodash-es';

import { DEFAULT_BORDER_COLOR } from '../constants.js';
import type { InternalTreeMapNode } from '../types/internal.js';

export const getNodeColor = (
  entry: HierarchyRectangularNode<InternalTreeMapNode>,
): string => {
  const isRootNode = !isUndefined(entry.data.color);
  const color = isRootNode ? entry.data.color : entry.parent?.data.color;
  return color?.Default ?? DEFAULT_BORDER_COLOR;
};
